module.exports = __webpack_public_path__ + "static/img/IMG_6342.d8e8ba7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/nyomtatott-uvegora/IMG_6342.jpg
// module id = 601
// module chunks = 0